export default __webpack_public_path__ + "static/media/step-1-ar.9f9b3c64.png";